module.exports = __webpack_public_path__ + "img/Tier.a5cf8fe8.svg";